import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["removeEmptySections"];
import { immerable } from 'immer';
import GridNode from './GridNode';
import { GRID_NODE_TYPES } from './constants';
import { iterateFrom, mergeIntoPath } from './utils';
import { GridLayoutTypename } from '../../__generated__/chirp/com/hubspot/content/grid/layouts/rpc/GridLayoutsRpc';
class RootNode extends GridNode {
  constructor(...args) {
    super(...args);
    this[immerable] = true;
  }
  cloneAndChange(rootNodeParams) {
    const {
      id,
      childNodeIds,
      value,
      treeRef
    } = rootNodeParams;
    const newNodeParams = {
      id: id !== null && id !== void 0 ? id : this._id,
      type: GRID_NODE_TYPES.ROOT,
      treeRef: treeRef !== null && treeRef !== void 0 ? treeRef : this._treeRef,
      childNodeIds: childNodeIds !== null && childNodeIds !== void 0 ? childNodeIds : this._childNodeIds,
      value: value !== null && value !== void 0 ? value : this._value
    };
    return newNodeParams.treeRef.createNewRootNode(newNodeParams);
  }
  serializeNode(_ref) {
    let {
        removeEmptySections = false
      } = _ref,
      options = _objectWithoutPropertiesLoose(_ref, _excluded);
    const content = this.getChildNodes().reduce((acc, child) => {
      if (removeEmptySections && child.isSection() && !child.hasChild()) {
        return acc;
      }
      acc.push(child.serializeNode(Object.assign({
        removeEmptySections
      }, options)));
      return acc;
    }, []);
    return Object.assign({}, this.getValue(), {
      content,
      __typename: GridLayoutTypename
    });
  }
  exportNode() {
    return {
      id: this.getId(),
      value: this.getValue(),
      parentNodeId: undefined,
      childNodeIds: [...this.getChildNodeIds()]
    };
  }
  getValue() {
    return this._value;
  }
  getChildNodes() {
    return this.getChildNodeIds().map(childNodeId => this.getTree().findNode(childNodeId));
  }
  mergeIntoValue(partialValue, path) {
    return this.cloneAndChange({
      value: mergeIntoPath(this._value, partialValue, path)
    });
  }
  getLabel() {
    return this.getValue().label;
  }
  getAllDescendantNodeIds() {
    const descendantNodeIds = [];
    iterateFrom(this, {
      includeStartNode: false,
      gridNodeCallback: ({
        gridNode
      }) => {
        descendantNodeIds.push(gridNode.getId());
      }
    });
    return descendantNodeIds;
  }
}
export default RootNode;